import apiUrl from '../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
import viewticket from '../viewticket'

export default {
	name: 'ticketlisting',
	components: {
		viewticket,
		Pagination,
		DatePicker,
		Loader,
	},
	data: function() {
		return {
			isLoading: false,
			listClientData: [],
			listWarehouseData: [],
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			searchflag:false,
			clientList: [],
			warehouseList: [],
			ClientErr: '',
			WarehouseErr: '',
			currentPage: 1,
			totalPage: 0,
			totalCount: 0,
			pageLimit: 10,
			totalRows: 0,
			showlist: false,
			helpTopic: '',
			helpTopicData: [],
			status: '',
			ticketNo: '',
			fromDateFlt: '',
			toDateFlt: '',
			statusData: [],
			listTicketData: [],
			userEmail: '',
			isLoading1: '',
			formattedDate: '',
			selectedRow: {},
			filterData: {},
		}
	},
	// when a page loads,mounted() will be call
	mounted() {
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.calldateFunction()
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userEmail = userdetail.email
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;
			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;
			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				break;
			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.checkTicketlogin(0, userdetail.userid, userdetail.fullname, userdetail.email)
		this.getHelpTopics()

	},
	methods: {
		showAddForm(data) {
			this.selectedRow = data
			this.showlist = true;
		},
		callParent() {
			this.showlist = false;
		},
		getHelpTopics() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getHelpTopics',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data.status) {
						this.helpTopicData = result.data.data
						this.statusData = result.data.status
						this.isLoading = false
						this.ticketFilterSearch()
					}

				}, error => {
					console.error(error)
				})
		},
		validateForm() {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log("Invalid Form");
					return false;
				} else {
					this.ticketFilterSearch()
					this.searchflag=true;
					console.log("Valid Form");
				}
			}).catch(() => {
				console.log('errors exist')
			});
		},
		ticketFilterReset() {
			document.getElementById('ticketNo').value = ''
			this.ticketNo = ''
			this.helpTopic = ''
			this.status = ''
			this.fromDateFlt = ''
			this.toDateFlt = ''
			this.listTicketData = []
			this.currentPage = 1
			this.totalPage = 0
			this.totalCount = 0
			this.totalRows = 0
			this.client = ''
			this.warehouse = ''
			this.$validator.reset()
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YY-MM-DD');
		},
		calldateFunction: function() {
			this.toDateFlt = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			var dt = new Date(this.toDateFlt);
			dt.setDate(dt.getDate() - 7);
			this.fromDateFlt = dt;
		},
		checkDateFilters() {
			var a = moment(this.dateFormat(this.fromDateFlt), "YYYY-MM-DD");
			var b = moment(this.dateFormat(this.toDateFlt), "YYYY-MM-DD");
			let days = moment.duration(b.diff(a)).asDays();
			if (this.fromDateFlt && this.fromDateFlt != '' && this.toDateFlt && this.toDateFlt != '' && days > 90) {
				this.fromDateFlt = ''
				this.toDateFlt = ''
				this.$alertify.error(this.$t('editedjson.maxDateDiff'));
			}
			let today = this.dateFormat(new Date().toJSON().slice(0, 10).replace(/-/g, '/'));
			var toA = moment(today, "YYYY-MM-DD");
			var toB = moment(this.dateFormat(this.toDateFlt), "YYYY-MM-DD");
			let diff = moment.duration(toB.diff(toA)).asDays();
			if (this.toDateFlt && this.toDateFlt != "" && diff > 0) {
				this.toDateFlt = ''
				this.$alertify.error(this.$t('common.dateCannotGreaterThanCurrentErr'));
			}
		},
		helpTopicName(id) {
			let topicName = id
			this.helpTopicData.forEach((el) => {
				if (Number(id) == el.topicid) {
					topicName = el.topicname
				}
			})
			return topicName
		},
		ticketListing() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var clientSearch = false
			var warehouseSearch = false
			if (this.client != null) {
				clientSearch = true
			}
			if (localStorage.getItem("selectedWarehouse") != null) {
				warehouseSearch = true
			}
			var input = ({
				"useremail": this.userEmail,
				// "offset": (this.currentPage - 1) * 10,
				"offset": 0,
				"limit": this.pageLimit,
				"fromdate": this.dateFormat(this.fromDateFlt),
				"todate": this.dateFormat(this.toDateFlt),
				"status_id": this.status,
				"topic_id": this.helpTopic,
				"number": this.ticketNo
			})
			this.listTicketData = []
			this.isLoading1 = true
			axios({
					method: "post",
					url: apiUrl.api_url + "ticketListing",
					'data': input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((response) => {
					if (response.data.status) {
						this.totalRows = Number(response.data.data.total_count)
						if (this.totalRows > 0) {
							if (this.totalRows <= this.pageLimit) {
								this.totalPage = 1;
							} else {
								this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
							}
						} else {
							this.totalPage = 0;
						}
						response.data.data.ticket_data.forEach((el) => {
							let str = el.subject;
							let string_split = str.split(",") ? str.split(",") : null;
							if (str.indexOf("Client!!!") < 0 && str.indexOf("Warehouse!!!") < 0 && str.indexOf("Subject!!!") < 0) {
								this.listTicketData.push({
									"subject": el.subject,
									"ticket_id": el.ticket_id,
									"number": el.number,
									"staff_id": el.staff_id,
									"topic_id": el.topic_id,
									"assigned": el.assigned,
									"current_status": el.current_status,
									"status_id": el.status_id,
									"topic": el.topic,
									"created": el.created,
									"clientname": null,
									"warehousename": null
								})
							} else {
								let warehouseName = string_split[1].split("Warehouse!!!")[1] ? string_split[1].split("Warehouse!!!")[1] : null;
								let subject = string_split[2].split("Subject!!!")[1] ? string_split[2].split("Subject!!!")[1] : null;
								let clientName = string_split[0].split("Client!!!")[1] ? string_split[0].split("Client!!!")[1] : null;
								this.listTicketData.push({
									"subject": subject,
									"ticket_id": el.ticket_id,
									"number": el.number,
									"staff_id": el.staff_id,
									"topic_id": el.topic_id,
									"assigned": el.assigned,
									"current_status": el.current_status,
									"status_id": el.status_id,
									"topic": el.topic,
									"created": el.created,
									"clientname": clientName,
									"warehousename": warehouseName
								})
							}
						})
						if (clientSearch) {
							let clientNameForSearch = ''
							this.listClientData.forEach((el) => {
								if (el.clientid == this.client) {
									clientNameForSearch = el.clientname
								}
							})
							let arrayBeforeClientSearch = this.listTicketData
							this.listTicketData = []
							arrayBeforeClientSearch.forEach((el) => {
								if (el.clientname && el.clientname == clientNameForSearch) {
									this.listTicketData.push(el)
								}
							})
						}
						if (warehouseSearch) {
							let warehouseNameForSearch = ''
							this.listWarehouseData.forEach((el) => {
								if (el.warehouseid == this.warehouse) {
									warehouseNameForSearch = el.warehousename
								}
							})
							let arrayBeforeWarehouseSearch = this.listTicketData
							this.listTicketData = []
							arrayBeforeWarehouseSearch.forEach((el) => {
								if (el.warehousename && el.warehousename == warehouseNameForSearch) {
									this.listTicketData.push(el)
								}
							})
						}
					} else {
						if(this.searchflag==true){
						this.$alertify.error(response.data.data.msg ? response.data.data.msg : response.data.msg);
						}
					}
					this.isLoading1 = false
				}).catch((error) => {
					this.isLoading1 = false
					console.log(error);
				});
		},
		onPageChange(page) {
			this.currentPage = page;
			this.ticketListing()
		},
		ticketFilterSearch() {
			this.currentPage = 1;
				this.ticketListing();
		},
		checkTicketlogin(check, userId, userName, userEmail) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var input = ({
				check: check,
				userid: userId,
				username: userName,
				useremail: userEmail
			})
			this.isLoading = true
			axios({
					method: "post",
					url: apiUrl.api_url + "ticketLoginUpdate",
					'data': input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((response) => {
					if (response.data.ticketlogin == 0) {
						this.$router.push('/osticket');
					}
					this.isLoading = false
				}).catch((error) => {
					this.isLoading = false
					console.log(error);
				});
		},


		// getWarehouseList() {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageNo = this.pageCount = 0;
		// 	this.input = ({
		// 		clientid: this.clientid,
		// 	});
		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 		.then(result => {
		// 			if (result.data.data && result.data.data.length > 0) {
		// 				this.listWarehouseData = result.data.data;
		// 				var warehouseListArray = [];
		// 				result.data.data.forEach(function(item) {
		// 					warehouseListArray[item.warehouseid] = item.warehousename;
		// 				});
		// 				this.warehouseList = warehouseListArray;
		// 			}
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// },

		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		var clientList = JSON.parse(plaintextclient);
		// 		var clientListArray = [];
		// 		clientList.forEach(function(item) {
		// 			clientListArray[item.clientid] = item.clientname;
		// 		});
		// 		this.clientList = clientListArray;
		// 		this.listClientData = clientList;
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});
		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				if (result.data.data && result.data.data.length > 0) {
		// 					this.listClientData = result.data.data;
		// 					var clientListArray = [];
		// 					result.data.data.forEach(function(item) {
		// 						clientListArray[item.clientid] = item.clientname;
		// 					});
		// 					this.clientList = clientListArray;
		// 				}
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 		}
		// 	}
		// 	this.listInwardMasterData = [];
		// 	this.pageNo = this.pageCount = 0;
		// },

		// warehouseSelected() {
		// 	this.totalRows = 0
		// 	this.warehouseid = this.warehouse;
		// 	this.pageNo = this.pageCount = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			//do nothing
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
	}
}


// WEBPACK FOOTER //
// ./src/views/components/ticketlisting/ticketlisting.component.js